import { Tabs, TabsContent, TabsList, TabsTrigger } from "@workspace/web-ui/components/tabs";
import activeMedication from "~/assets/images/dashboard/active-medications.svg";
import allergiesImage from "~/assets/images/dashboard/allergies-medicals.svg";
import emptyMedication from "~/assets/images/dashboard/empty-medication.svg";
import healthCondition from "~/assets/images/dashboard/health-condition.svg";
import SubNav from "../../components/sub-nav";

import { useSuspenseQuery } from "@tanstack/react-query";
import { Modal } from "../../components/modal";
import {
  activeMedicationsQueryOptions,
  medicalsAllergiesQueryOptions,
  medicalsConditionsQueryOptions,
  medicalsMedicationsRefillHistoryQueryOptions,
  medicalsMedicationsRefillProcessingQueryOptions
} from "./api/queries";
import ActiveMedication from "./components/active-medications";
import AllergiesCard from "./components/allergies-card";
import { CurrentRefill } from "./components/current-processing";
import EmptyMedicalCard from "./components/empty-medical-cards";
import { AllergyForm } from "./components/forms/allergy-form";
import { ConditionForm } from "./components/forms/condition-form";
import HealthConditionCard from "./components/health-condition-card";
import MedicationRefillHistory from "./components/medical-history";
import ReminderCard from "./components/request-card";
import { useAllergyModal } from "./store/allergy-modal";
import { useConditionModal } from "./store/condition-modal";
import { linkOptions, useNavigate, useParams } from "@tanstack/react-router";

export const medicalsLinkOptions = (tab = 'medications') => linkOptions({
  to: '/dashboard/weight-loss/medicals/$tab',
  params: { tab }
})

export function MedicalsTabPage() {
  const { tab } = useParams({ strict: false })
  const navigate = useNavigate()

  const medicationsQuery = useSuspenseQuery(activeMedicationsQueryOptions())
  const refillHistoryQuery = useSuspenseQuery(medicalsMedicationsRefillHistoryQueryOptions())
  const refillProcessingQuery = useSuspenseQuery(medicalsMedicationsRefillProcessingQueryOptions())
  const conditionsQuery = useSuspenseQuery(medicalsConditionsQueryOptions("weight_loss"))
  const allergiesQuery = useSuspenseQuery(medicalsAllergiesQueryOptions("weight_loss"))

  const { isOpen: isConditionModalOpen, open: openConditionModal, close: closeConditionModal } = useConditionModal()
  const { isOpen: isAllergyModalOpen, open: openAllergyModal, close: closeAllergyModal } = useAllergyModal()


  return (
    <main className="flex flex-col gap-6">
      <section className="py-10">
        <SubNav
          title="Medicals"
          buttonOne="Go to urgent care"
          buttonTwo="Book an appointment"
        />
        {/* Subnav Two - Accordion */}
        <div className="space-y-8">
          <Tabs defaultValue="medications" value={tab} onValueChange={(tab) => navigate(medicalsLinkOptions(tab))}>
            <TabsList className="h-12 w-full justify-start gap-6 rounded-none border-b mb-3 py-0">
              <TabsTrigger
                value="medications"
                className="h-full rounded-none border-b-2 border-transparent  px-2 py-4 text-sm data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none"
              >
                Medications & History
              </TabsTrigger>
              <TabsTrigger
                value="conditions"
                className="h-full rounded-none border-b-2 border-transparent px-0 text-sm data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none"
              >
                Conditions & allergies
              </TabsTrigger>
            </TabsList>

            <TabsContent value="medications" className="lg:flex-row  flex flex-col sm:gap-4">
              <div className="flex-1">
                {medicationsQuery.data?.active_medications && medicationsQuery.data?.active_medications?.length > 0 ? <ActiveMedication medicalItems={medicationsQuery.data?.active_medications} /> : <EmptyMedicalCard
                  title="Active medications"
                  image={activeMedication}
                  description="Nothing yet"
                  altImg={"active medication"}
                  message="You currently do not have any medications listed."
                />}

                {refillProcessingQuery.data && refillProcessingQuery.data?.length > 0 ? <CurrentRefill currentRefillsItems={refillProcessingQuery.data} /> : <EmptyMedicalCard
                  title="Currently Processing Medications"
                  image={emptyMedication}
                  description="Nothing yet"
                  altImg={"current medication"}
                  message="You currently do not have any medications listed."
                />}

                {refillHistoryQuery.data?.refill_history && refillHistoryQuery.data?.refill_history?.length > 0 ? <MedicationRefillHistory refillHistory={refillHistoryQuery.data?.refill_history} /> : <EmptyMedicalCard
                  title="Medication Refill History"
                  image={emptyMedication}
                  description="Nothing yet"
                  altImg={"medication history"}
                  message="You currently do not have any history yet"
                />
                }
              </div>
              <ReminderCard />
            </TabsContent>

            <TabsContent value="conditions" className="flex-col flex ">
              <div className="flex-col flex md:flex-row gap-4">
                {allergiesQuery.data?.allergies && allergiesQuery.data?.allergies?.length > 0 ?
                  <AllergiesCard items={allergiesQuery.data?.allergies} onButtonClick={() => { openAllergyModal() }} /> :
                  <EmptyMedicalCard
                    title="Allergies"
                    image={allergiesImage}
                    description=""
                    altImg={"allergies"}
                    message={`You currently do not have any health allergies listed `}
                    showButton={true}
                    buttonText="Add allergies"
                    onButtonClick={() => { openAllergyModal() }}
                  />}

                {conditionsQuery.data?.conditions && conditionsQuery.data?.conditions?.length > 0 ?
                  <HealthConditionCard items={conditionsQuery.data?.conditions} onButtonClick={() => { openConditionModal() }} /> :
                  <EmptyMedicalCard
                    title="Health Conditions"
                    image={healthCondition}
                    description=""
                    altImg={"condition"}
                    message={`You currently do not have any health conditions listed`}
                    showButton={true}
                    buttonText="Add conditions"
                    onButtonClick={() => { openConditionModal() }}
                  // onButtonClick={() => { setChatTitle("Add Conditions and Allergies"); setIsChatOpen(true) }}
                  />}
              </div>
            </TabsContent>
          </Tabs>
        </div>

        {/* <Chatbot title={chatTitle} isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} /> */}
        <Modal isOpen={isConditionModalOpen} onClose={closeConditionModal} title={"Add Conditions"}>
          <ConditionForm onClose={closeConditionModal} />
        </Modal>
        <Modal isOpen={isAllergyModalOpen} onClose={closeAllergyModal} title={"Add Allergies"}>
          <AllergyForm onClose={closeAllergyModal} />
        </Modal>
      </section>
    </main>
  )
}

